import { useMe } from '@/lib/useMe';

/**
 * The whole of Phase 0's authenticated content: nothing but a statement of
 * who is signed in and as what role. Phase 1 replaces this with the first
 * real destination (support-admin-proposal.md §6); until then this page is
 * the proof the shell, the session gate and the role it read all work.
 */
export function OverviewPage() {
  const { data: me } = useMe();
  if (!me) return null;

  return (
    <div>
      <h1 className="text-h2 font-semibold text-fg-primary">Overview</h1>
      <p className="mt-2 text-body text-fg-secondary">
        Signed in as <span className="font-medium text-fg-primary">{me.email}</span>, role{' '}
        <span className="font-medium text-fg-primary">{me.role}</span>.
      </p>
    </div>
  );
}
